export default "__VITE_ASSET__BB_afXf4__"